import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/pathBuilder';
import Tooltip from 'components/shared/Tooltip';
import addModifiers from 'utils/add_modifiers';

const SaveDraftButton = ({ saveDraft, hasUnsavedChanges, loading }) => (
  <Tooltip text={hasUnsavedChanges.reason} inline>
    <button
      type="button"
      className={addModifiers('NewButton', ['tallAndWide', 'blue'])}
      onClick={!loading ? saveDraft : null}
      disabled={!hasUnsavedChanges.value}
    >
      {loading && <span className="Spinner mr-4" />}{' '}
      {t('paths.path_builder.button_save_draft')}
    </button>
  </Tooltip>
);

const mapStateToProps = ({ pathBuilder }) => ({
  loading: pathBuilder.updateInProgress,
});

const mapDispatchToProps = {
  saveDraft: actions.saveDraft,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveDraftButton);
